import React from 'react';
import PropTypes from 'prop-types';
import CustomAlertDialogBase from './CustomAlertDialogBase';

class CustomAlertDialog extends React.Component {
  static propTypes = {
    cancelText: PropTypes.string.isRequired,
    className: PropTypes.string,
    onCancel: PropTypes.func,
    open: PropTypes.bool.isRequired,
    styleType: PropTypes.string,
    maxWidthBtn: PropTypes.bool,
  };
  static defaultProps = {
    styleType: 'default',
  };
  getStyles = type => {
    switch (type) {
      default:
        return {
          rootPaper: {
            width: '640px',
            padding: '0px',
          },
          contentRoot: {
            padding: '23px 0px 0px 0px',
          },
          divider: {
            marginTop: '35px',
          },
          title: {
            fontSize: '20px',
            fontWeight: 'normal',
            color: '#2E2E38',
            padding: '19px 0 16px 20px',
            fontFamily: '"EYInterstate", sans-serif',
          },
          header: {
            borderBottom: '1px solid #E1E1E6',
          },
          closeIcon: {
            paddingTop: '15px',
            marginRight: '15px',
          },
          contentText: {
            paddingLeft: '20px',
            color: '#2E2E38',
            fontSize: '14px',
            fontWeight: '300',
          },
          actionsRoot: {
            margin: '11px 0px 11px 11px',
          },
        };
    }
  };
  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <CustomAlertDialogBase styles={styles} {...otherProps} />;
  }
}

export default CustomAlertDialog;
